'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nflex-direction: column;\ntext-align: center;\npadding: 10px;\n\n& > svg {\n\n},\n& > img {\n  width: 80px;\n  height: auto;\n  margin-bottom: 5px;\n  color: ", "\n}\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\ndisplay: flex;\nalign-items: center;\njustify-content: flex-start;\ngap: 0.625rem;\nmargin-right: 10px;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\ncolor: ", " !important;\n\n  // &.active {\n  //   text-decoration: underline;\n  // }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  max-height: calc(100vh - 100px);\n  padding: 24px;\n  overflow-y: auto;\n\n  background: ", " !important;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 16px;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  color: ", " !important;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n\n.ant-menu-item {\n  padding: 4px 23px;\n\n  &:hover{\n    background: unset !important;\n    color: unset;\n  }\n\n  &.ant-menu-item-selected {\n    background: unset !important;\n    a {\n      position: relative;\n      z-index: 1;\n    }\n    \n\n  }\n\n  &.ant-menu-item-disabled > a {\n    opacity: 0.47;\n    color: @primary-color!important;\n  }\n}\n\n  text-transform: uppercase;\n color: ", " !important;\n\n\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20.8px;\n  cursor: pointer;\n  margin-bottom: 40px;\n  font-size: 12px;\n  &:last-child {\n    margin: 0;\n  }\n  a {\n    color: ", ";\n  }\n  svg {\n    vertical-align: sub;\n    margin-right: 12px;\n    color: ", ";\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  max-width: 168px;\n  width: 168px;\n  margin: 10px 0 40px;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid ", ";\n  opacity: 0.2;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  transform: translateY(-50%);\n  height: 3px;\n  background: ", ";\n\n  transition: background 0.3s;\n  &:after {\n    content: '';\n    top: -6px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    height: 3px;\n    background: ", "; \n    transform: rotate(0deg);\n    transition: transform 0.3s, top 0.3s;\n    ", "\n  }\n  &:before {\n    content: '';\n    bottom: -6px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    height: 3px;\n    background: ", "; \n    transform: rotate(0deg);\n    transition: transform 0.3s, bottom 0.3s;\n    ", "\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n  z-index: 1000;\n  width: 16px;\n  height: 15px;\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  \n  background: ", " !important;\n        \n \n  color: ", "\n  ", "\n  text-align: left;\n  padding: 40px 0 24px;\n\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        display: inline-block;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  \n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      height: 40px !important;\n      background-color: ", ";\n\n      border: 0 !important;\n\n      a {\n        color: ", ";\n        opacity: 0.5;\n        cursor: default;\n\n        svg.icon {\n          color: ", ";\n\n          \n        }\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n       {\n        border-top-right-radius: 2px;\n        border-bottom-right-radius: 2px;\n        \n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n       {\n        border-top-left-radius: 2px;\n        border-bottom-left-radius: 2px;\n\n        \n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n         {\n          margin-right: 3px;\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\n.header-menu,\n.ant-menu-item,\n.ant-menu-submenu{\n  a {\n    color: isSp() ? black : red;\n  \n    &:focus,\n    &:hover,\n    &:active{\n      text-decoration: none;\n    }\n  }\n}\n\n.ant-menu-vertical-right {\n    border-left: none !important;\n}\n\n\n\n.fa  {\n   margin-right: 10px;\n   font-size: 17px;\n}\n\n  &.ant-menu-submenu-disabled {\n    margin: 0;\n    .ant-menu-submenu-title {\n      cursor: default;\n      padding: 0 12px;\n      .icon {\n        color: ", ";\n      }\n      a{\n        color: ", ";\n        padding: 0;\n      }\n    }\n\n    ", "\n  }\n\n  ", "\n\n  ", "\n        \n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\n   background: ", " !important;\n  .submenu-item-name {\n    margin: 0 0 0 10px !important;\n  }\n\n  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected{\n    background: ", " !important;\n    border-left: ", " !important;\n  }\n\n\n}\n\n\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _antd = require('antd');

var _styled = require('../../../styled');

var _theme = require('../../../styled/theme');

var _theme2 = _interopRequireDefault(_theme);

var _mediaTemplates = require('../../../styled/mediaTemplates');

var _NotificationBadge = require('./NotificationBadge');

var _NotificationBadge2 = _interopRequireDefault(_NotificationBadge);

var _reactRouterDom = require('react-router-dom');

var _colorUtils = require('../../../utils/colorUtils');

var _isSp = require('../../../utils/isSp');

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var THEME_COLOR = {
  BLACK: 'BLACK',
  WHITE: 'WHITE'
};
var isSpCheck = (0, _isSp.isSp)();

var Sider = _styledComponents2.default.div(_templateObject(), function (_ref) {
  var isSpCheck = _ref.isSpCheck,
      accentColor = _ref.accentColor;
  return isSpCheck ? (0, _colorUtils.lightenColor)(accentColor, 0.7) : '#0E181D';
}, function (_ref2) {
  var isSpCheck = _ref2.isSpCheck,
      accentColor = _ref2.accentColor;
  return isSpCheck ? '#F2F2F2' : '#122027';
}, function (_ref3) {
  var isSpCheck = _ref3.isSpCheck,
      accentColor = _ref3.accentColor;
  return isSpCheck ? "3.8px solid ".concat(accentColor, ";") : '3.8px solid #1D3B49;';
});

var MenuStyled = (0, _styledComponents2.default)(_antd.Menu)(_templateObject2());
var SubMenuStyled = (0, _styledComponents2.default)(_antd.Menu.SubMenu)(_templateObject3(), _theme2.default.gray, _theme2.default.gray, function (props) {
  return props.last && _styledComponents.css(_templateObject4());
}, function (props) {
  return props.first && _styledComponents.css(_templateObject5());
}, function (props) {
  return props.last && _styledComponents.css(_templateObject6());
}, function (props) {
  return props.disabled && _styledComponents.css(_templateObject7(), _styled.colors.silver.light, props.theme.gray, props.theme.gray);
});

var MobileMenu = _styledComponents2.default.div(_templateObject8(), _mediaTemplates.media.allMobiles(_templateObject9()));

var MobileMenuList = _styledComponents2.default.div(_templateObject10(), function (_ref4) {
  var isSpCheck = _ref4.isSpCheck,
      accentColor = _ref4.accentColor;
  return isSpCheck ? (0, _colorUtils.lightenColor)(accentColor, 0.7) : '#0E181D';
}, _theme2.default.gray, function (props) {
  return props.isOpen && 'display: block';
});

var MobileMenuBurgerWrapper = _styledComponents2.default.div(_templateObject11(), _mediaTemplates.media.allMobiles(_templateObject12(), function (props) {
  return props.isOpen && 'margin-right: 8px;';
}));

var MobileMenuBurger = _styledComponents2.default.span(_templateObject13(), function (props) {
  return props.isOpen ? 'transparent' : _theme2.default.BurgerMenu;
}, function (props) {
  return props.theme.BurgerMenu;
}, function (props) {
  return props.isOpen && 'transform: rotate(-45deg); top: 0;';
}, function (props) {
  return props.theme.BurgerMenu;
}, function (props) {
  return props.isOpen && 'transform: rotate(45deg); bottom: 0;';
});

var StyledHr = _styledComponents2.default.hr(_templateObject14(), function (props) {
  return props.theme.platformPrimary;
});

var MobileMenuItem = _styledComponents2.default.div(_templateObject15(), function (_ref5) {
  var userTheme = _ref5.userTheme;
  return (0, _isSp.isSp)() ? '#1A1A1A' : userTheme === THEME_COLOR.BLACK ? '#D3D4D9' : 'inherit';
}, function (props) {
  return props.disabled ? _styled.colors.gray.light : '#286684';
}, function (props) {
  return props.disabled ? _styled.colors.gray.light : '#286684';
});

var LinkLike = _styledComponents2.default.span(_templateObject16(), function (props) {
  return props.theme.gray;
});

var StyledNotificationBadge = (0, _styledComponents2.default)(_NotificationBadge2.default)(_templateObject17());

var MobileMenuListWrap = _styledComponents2.default.div(_templateObject18(), function (_ref6) {
  var isSpCheck = _ref6.isSpCheck,
      accentColor = _ref6.accentColor;
  return isSpCheck ? (0, _colorUtils.lightenColor)(accentColor, 0.7) : '#0E181D';
});

var StyledNavLink = (0, _styledComponents2.default)(_reactRouterDom.NavLink)(_templateObject19(), function (props) {
  return props.theme.gray;
});

var NotificationBurgerMenu = _styledComponents2.default.div(_templateObject20());

var MobileSection = _styledComponents2.default.div(_templateObject21(), function (props) {
  return props.theme.gray;
});

exports.default = {
  Sider: Sider,
  MenuStyled: MenuStyled,
  MobileSection: MobileSection,
  NotificationBurgerMenu: NotificationBurgerMenu,
  SubMenuStyled: SubMenuStyled,
  MobileMenuList: MobileMenuList,
  MobileMenuListWrap: MobileMenuListWrap,
  MobileMenuBurger: MobileMenuBurger,
  MobileMenuBurgerWrapper: MobileMenuBurgerWrapper,
  MobileMenu: MobileMenu,
  StyledHr: StyledHr,
  MobileMenuItem: MobileMenuItem,
  StyledNotificationBadge: StyledNotificationBadge,
  LinkLike: LinkLike,
  NavLink: StyledNavLink
};